var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFifa18Highlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29451",
    "data-name": "Group 29451",
    transform: "translate(-422 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(422 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-fifa18",
    transform: "translate(434.919 577.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50757",
    "data-name": "Path 50757",
    d: "M34.073,17.541H32.98v1.435h.528a.4.4,0,0,1,.412.412v5.387h1.74V19.133A1.541,1.541,0,0,0,34.073,17.541Z",
    transform: "translate(-14.428 -0.058)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50758",
    "data-name": "Path 50758",
    d: "M41.719,17.409c1.569,0,2.342.727,2.342,2a1.688,1.688,0,0,1-.912,1.6,1.73,1.73,0,0,1,1.018,1.7c0,.852-.291,2.1-2.453,2.1s-2.453-1.25-2.453-2.1a1.729,1.729,0,0,1,1.018-1.7,1.688,1.688,0,0,1-.912-1.6C39.378,18.136,40.151,17.409,41.719,17.409Zm0,2.972a.66.66,0,0,0,.523-.171.924.924,0,0,0,.157-.643.737.737,0,0,0-.171-.6.9.9,0,0,0-1.018,0,.742.742,0,0,0-.171.6.907.907,0,0,0,.157.643A.652.652,0,0,0,41.719,20.381Zm0,3.031a.771.771,0,0,0,.5-.116c.157-.111.236-.268.236-.727a.8.8,0,0,0-.208-.685.759.759,0,0,0-.532-.125.739.739,0,0,0-.532.13.8.8,0,0,0-.208.685c0,.458.083.615.236.727a.872.872,0,0,0,.51.111Z",
    transform: "translate(-17.183)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50759",
    "data-name": "Path 50759",
    d: "M25.585,17.508H24.049A1.545,1.545,0,0,0,22.461,19.1v5.642h1.745V19.355a.4.4,0,0,1,.412-.412h.412a.375.375,0,0,1,.412.412v1.486h-.921v1.435h.921v2.463h1.741V19.1a1.554,1.554,0,0,0-1.6-1.592Z",
    transform: "translate(-9.815 -0.043)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50760",
    "data-name": "Path 50760",
    d: "M13.526,19.109v5.632h1.759V21.849h1.962V20.4H15.28V19.369a.4.4,0,0,1,.412-.417h2.273V17.508H15.128A1.557,1.557,0,0,0,13.526,19.109Z",
    transform: "translate(-5.896 -0.043)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50761",
    "data-name": "Path 50761",
    d: "M9.1,17.508h1.754v7.229H9.1Z",
    transform: "translate(-3.955 -0.043)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50762",
    "data-name": "Path 50762",
    d: "M.081,19.109v5.632H1.84V21.849H3.8V20.4H1.839V19.369a.4.4,0,0,1,.412-.417H4.524V17.508H1.682A1.557,1.557,0,0,0,.081,19.109Z",
    transform: "translate(0 -0.043)",
    fill: "#37474f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifa18Highlighted);
export default __webpack_public_path__ + "static/media/fifa18Highlighted.a3c3e12286b98817f385ded9d4c07cad.svg";
export { ForwardRef as ReactComponent };